module.exports = __webpack_public_path__ + "img/mdg.67f5922d.svg";